// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"src-components-HelloWorld-HelloWorld__title--1Oeaf"};